export type FunnelEventName =
  | 'landing_viewed'
  | 'sign_in_clicked'
  | 'auth_redirect_started'
  | 'auth_redirect_failed'
  | 'auth_redirect_returned'
  | 'auth_callback_started'
  | 'auth_callback_succeeded'
  | 'auth_callback_failed'
  | 'account_state_resolved'
  | 'signup_form_viewed'
  | 'signup_form_submitted'
  | 'signup_completed'
  | 'waitlist_joined'
  | 'billing_viewed'
  | 'billing_plan_selected'
  | 'billing_confirmed'
  | 'app_dashboard_viewed';

export type TelemetryProperties = Record<string, string | number | boolean | null | undefined>;

export function errorTelemetryProperties(error: unknown): TelemetryProperties {
  if (error instanceof Error) {
    return {
      errorName: error.name,
      errorMessage: error.message,
    };
  }
  return {
    errorMessage: String(error || 'Unknown error'),
  };
}
